export enum FollowUp {
    LastWeek = 0,
    Yesterday = 1,
    Today = 2,
    Tomorrow = 3,
    ThisWeek = 4,
    NextWeek = 5,
    Custom = 6
}
